export const SI_NO = [
  { value: 1, label: 'SI' },
  { value: 0, label: 'NO' },
];

export const DIAS_SEMANA = (type = 'normal', position = 'start') => {
  const configs = {
    normal: [],
    all: [{ value: 0, label: 'TODOS' }],
    extras: [
      { value: 0, label: 'TODOS' },
      { value: 99, label: 'ENTRE SEMANA' },
      { value: 98, label: 'FIN DE SEMANA' },
    ],
  };

  const days = [
    { value: 1, label: 'LUNES' },
    { value: 2, label: 'MARTES' },
    { value: 3, label: 'MIÉRCOLES' },
    { value: 4, label: 'JUEVES' },
    { value: 5, label: 'VIERNES' },
    { value: 6, label: 'SÁBADO' },
    { value: 7, label: 'DOMINGO' },
  ];

  const configuracionTipo = configs[type] || configs.normal;

  if (position === 'start') return [...configuracionTipo, ...days];
  else return [...days, ...configuracionTipo];
};

export const ESTADOS_MEXICO = [
  { value: 1, label: 'Aguascalientes' },
  { value: 2, label: 'Baja California' },
  { value: 3, label: 'Baja California Sur' },
  { value: 4, label: 'Campeche' },
  { value: 5, label: 'Chiapas' },
  { value: 6, label: 'Chihuahua' },
  { value: 7, label: 'Ciudad de México' },
  { value: 8, label: 'Coahuila' },
  { value: 9, label: 'Colima' },
  { value: 10, label: 'Durango' },
  { value: 11, label: 'Guanajuato' },
  { value: 12, label: 'Guerrero' },
  { value: 13, label: 'Hidalgo' },
  { value: 14, label: 'Jalisco' },
  { value: 15, label: 'Estado de México' },
  { value: 16, label: 'Michoacán' },
  { value: 17, label: 'Morelos' },
  { value: 18, label: 'Nayarit' },
  { value: 19, label: 'Nuevo León' },
  { value: 20, label: 'Oaxaca' },
  { value: 21, label: 'Puebla' },
  { value: 22, label: 'Querétaro' },
  { value: 23, label: 'Quintana Roo' },
  { value: 24, label: 'San Luis Potosí' },
  { value: 25, label: 'Sinaloa' },
  { value: 26, label: 'Sonora' },
  { value: 27, label: 'Tabasco' },
  { value: 28, label: 'Tamaulipas' },
  { value: 29, label: 'Tlaxcala' },
  { value: 30, label: 'Veracruz' },
  { value: 31, label: 'Yucatán' },
  { value: 32, label: 'Zacatecas' },
];
